import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule} from '@angular/material-moment-adapter';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {TranslateModule} from '@ngx-translate/core';
import {MxMaterialModule} from '../../../../material/mx-material.module';
import {MxSharedModule} from '../../../../shared/mx-shared.module';
import {MxAssignmentFieldComponent} from './components/mx-assignment-field/mx-assignment-field.component';
import {MxCheckBoxFieldComponent} from './components/mx-check-box-field/mx-check-box-field.component';
import {MxColorPickerComponent} from './components/mx-color-picker/mx-color-picker.component';
import {MxComboBoxFieldComponent} from './components/mx-combo-box-field/mx-combo-box-field.component';
import {MxDatePickerComponent} from './components/mx-date-picker/mx-date-picker.component';
import {MxDateRangeComponent} from './components/mx-date-range/mx-date-range.component';
import {MxDateTimeFieldComponent} from './components/mx-date-time-field/mx-date-time-field.component';
import {MxDynamicFieldsComponent} from './components/mx-dynamic-fields/mx-dynamic-fields.component';
import {MxFormFieldDirective} from './components/mx-dynamic-fields/mx-form-field.directive';
import {MxFieldSetComponent} from './components/mx-field-set/mx-field-set.component';
import {MxFileUploadFieldComponent} from './components/mx-file-upload-field/mx-file-upload-field.component';
import {MxHtmlFieldComponent} from './components/mx-html-field/mx-html-field.component';
import {MxNumericFieldComponent} from './components/mx-numeric-field/mx-numeric-field.component';
import {MxNumericInputDirective} from './components/mx-numeric-field/mx-numeric-input.directive';
import {MxPasswordFieldComponent} from './components/mx-password-field/mx-password-field.component';
import {MxTextAreaFieldComponent} from './components/mx-text-area-field/mx-text-area-field.component';
import {MxTextFieldComponent} from './components/mx-text-field/mx-text-field.component';
import {ColorPickerDirective} from 'ngx-color-picker';

@NgModule({
    imports: [
        AngularEditorModule,
        ColorPickerDirective,
        CommonModule,
        MxMaterialModule,
        MxSharedModule,
        MatMomentDateModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    exports: [
        MxDynamicFieldsComponent,
        MxTextFieldComponent,
        MxCheckBoxFieldComponent,
        MxColorPickerComponent,
        MxComboBoxFieldComponent,
        MxDatePickerComponent,
        MxDateRangeComponent,
        MxDateTimeFieldComponent,
        MxFileUploadFieldComponent,
        MxHtmlFieldComponent,
        MxNumericFieldComponent,
        MxPasswordFieldComponent,
        MxTextAreaFieldComponent,
        MxTextFieldComponent,
        MxFieldSetComponent,
        MxAssignmentFieldComponent,
        MxFormFieldDirective
    ],
    declarations: [
        MxDynamicFieldsComponent,
        MxCheckBoxFieldComponent,
        MxColorPickerComponent,
        MxComboBoxFieldComponent,
        MxDatePickerComponent,
        MxDateRangeComponent,
        MxDateTimeFieldComponent,
        MxFileUploadFieldComponent,
        MxHtmlFieldComponent,
        MxNumericFieldComponent,
        MxPasswordFieldComponent,
        MxTextAreaFieldComponent,
        MxTextFieldComponent,
        MxFieldSetComponent,
        MxFormFieldDirective,
        MxNumericInputDirective,
        MxAssignmentFieldComponent
    ],
    providers: [
        {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}}
    ]
})
export class MxDynamicFieldsModule { }
